import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { closeModal, openModal } from '@store/slices/uiSlice';
import type { UIModalId } from '@store/slices/uiSlice';

export const useModal = (id: UIModalId) => {
  const dispatch = useAppDispatch();
  const { activeModal, payload } = useAppSelector(state => state.ui.modal);

  return useMemo(
    () => ({
      isOpen: activeModal === id,
      payload: activeModal === id ? payload : null,
      open: (nextPayload?: Record<string, string | number | boolean | null>) =>
        dispatch(openModal({ id, payload: nextPayload })),
      close: () => dispatch(closeModal()),
    }),
    [activeModal, dispatch, id, payload]
  );
};
